import '../../styles/index.css'
import './Home.scss';
import Location from '../../components/Location/Location';
import CustomButton from '../../components/Buttons/CustomButton/CustomButton';
import MontagemButton from '../../assets/icons/Logo OnPrice Vermelho.svg';
import CarouselCategorias from '../../components/Carousels/CarouselCategorias/CarouselCategorias';
import { useNavigate } from 'react-router-dom';
import celularImg1 from '../../assets/img/Mockup\ Frente.png';
import celularImg2 from '../../assets/img/Mockup\ Trás.png';

function Home() {

  const navigate = useNavigate();

  return (
    <main className="home-container">

      <div className='page-container'>
        <Location local='Home' />
      </div>

      <section className="text-center mt-4 px-4">
        <h5 style={{ color: '#A80A01', fontStyle: 'italic' }}>Bem-Vindo ao OnPrice</h5>
        <p className="b2">
          Acesse o primeiro comparador de preços focado <span className='negrito'>100% em hardware</span> do Brasil.
        </p>
        <p className='mt-3'>Isso é OnPrice</p>
      </section>

      <section className='home-centro'>

        <div className='home-meio shadow'>

          <div className="ir-para-montagem">
            <h5>Monte seu Setup</h5>
            <p className="b2" id='fraseCriarSetup'>
              Crie seu Setup, peça por peça, enquanto compara os melhores preços
              do mercado.
            </p>
            <div className='mt-4'>
              <CustomButton texto={'Montar Setup'} cor={'white'} icone={MontagemButton} tipo='1' onClick={() => navigate('/Montagem')} data-cy="montagem-btn" />
            </div>
          </div>

          <div className='imagens-celulares'>
            <img src={celularImg2} alt="Celular" className='celular-tras'></img>
            <img src={celularImg1} alt="Celular" className='celular-frente'></img>
          </div>

        </div>

      </section>

      <section className='page-container py-3'>
        <CarouselCategorias />
      </section>

    </main>
  );
}

export default Home;
